import axios from 'axios';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, FormControl, FormGroup } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import swal from 'sweetalert2';
import {
  fetchUserFields,
  updateUserFields
} from '../redux/actions/app-actions';
import { setExpand } from '../redux/actions/pdf-actions';
import {
  fetchCategoryTypesByUser,
  fetchMysubscriptions
} from '../redux/actions/user-actions';
import { default as config, CONSTANTS } from '../constants/constants';
import { firebase } from '../firebase';
import AuthUserContext from '../session/auth_user_context';
import withAuthorization from '../session/with_authorization';
import { convertDate } from '../utils/utils';
import Navigation from '../components/header/Navigation';
import Paypal from '../features/profile/components/PaypalPage';
import PaypalPremium from '../features/profile/components/PaypalPremiumPage';
import {
  isUserStatusFree,
  isUserStatusInactive,
  isUserStatusNew,
  isUserStatusSubscribed
} from '../utils/CheckUserStatus';
import LoadingDots from '../components/ui/loading/LoadingDots';

const INITIAL_STATE = {
  newpassword: '',
  newpasswordconfirmation: '',
  error: null,
  showPass: false,
  subscriptionLoaded: false
};

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      subscriptions: null,
      autoplay: false,
      autotagging: false,
      nameOfUser: '',
      isAppleId: false,
      isSubscriptionLoading: false
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ isSubscriptionLoading: true });
      if (firebase.auth.currentUser !== null) {
        firebase.auth.currentUser.getIdToken().then((token) => {
          this.props.dispatch(fetchCategoryTypesByUser(token));
          this.props.dispatch(fetchUserFields(token)).then(() => {
            this.setState({
              autotagging: this.props.userFields?.auto_tagging,
              autoplay: this.props.userFields?.auto_play_serial
            });
          });

          const options = {
            method: 'GET',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/auth/user`
          };

          this.props.dispatch(fetchMysubscriptions(token));

          axios(options).then((result) => {
            if (result.data != null) {
              this.setState({ nameOfUser: result.data.name });
            }

            const opt = {
              method: 'GET',
              headers: { 'X-Firebase-Auth': token },
              url: `${config.serverURL}/subscription/`
            };
            axios(opt)
              .then((result) => {
                this.setState({ subscriptions: result.data });
              })
              .catch(() => {
                this.setState({ subscriptions: null });
              })
              .finally(() => {
                this.setState({ isSubscriptionLoading: false });
              });
          });
        });
      }
      this.props.dispatch(setExpand(false));
    }, 1500);
  }

  componentDidUpdate() {
    const context = this.context;
    if (context.authUser && !this.state.subscriptionLoaded) {
      // reload!
      this.setState({ subscriptionLoaded: true });
    }
  }

  toggleShowHide = () => {
    this.setState({ showPass: !this.state.showPass });
  };

  onSubmitName = (event) => {
    const { fullname } = this.state;
    let userToUpdate = {};

    let user = firebase.auth.currentUser;

    if (fullname !== undefined) {
      user.updateProfile({ displayName: fullname, photoURL: null }).then(() => {
        this.setState({ ...INITIAL_STATE });
        user.getIdToken().then((token) => {
          userToUpdate = {};

          userToUpdate.name = user.displayName;
          userToUpdate.email = user.email;
          userToUpdate.firebaseUserId = user.uid;

          const options = {
            method: 'PUT',
            headers: { 'X-Firebase-Auth': token },
            url: `${config.serverURL}/auth/user`,
            data: userToUpdate
          };

          axios(options)
            .then((result) => {
              if (result.data != null) {
                this.setState({ nameOfUser: result.data.name });
              }
              swal({
                imageUrl: CONSTANTS.swalLogo,
                title: '<div class="titleModal">Your name has changed.</div>',
                html: '<p class="contentModal"></p>',
                showConfirmButton: false,
                showCloseButton: true,
                background: '#121C24',
                allowOutsideClick: false
              });
            })
            .catch((e) => {
              // To do: Error handling
              const e1 = e;
              console.log(e);
            });
        });
      });
    }

    event.preventDefault();
  };

  onSubmitPassword = (event) => {
    const { newpassword, newpasswordconfirmation } = this.state;

    let user = firebase.auth.currentUser;

    if (newpassword !== newpasswordconfirmation) {
      swal({
        imageUrl: CONSTANTS.swalLogo,
        title: '<div class="titleModal">Notice</div>',
        html: '<p class="contentModal">Passwords must match.</p>',
        showConfirmButton: false,
        showCloseButton: true,
        background: '#121C24',
        allowOutsideClick: false
      });
    } else {
      user.updatePassword(newpassword).then(
        () => {
          swal({
            imageUrl: CONSTANTS.swalLogo,
            title: '<div class="titleModal">Your password has changed.</div>',
            html: '<p class="contentModal"></p>',
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        },
        (error) => {
          swal({
            imageUrl: CONSTANTS.swalLogo,
            title: '<div class="titleModal">Error</div>',
            html: `<p class="contentModal">${error.message}</p>`,
            showConfirmButton: false,
            showCloseButton: true,
            background: '#121C24',
            allowOutsideClick: false
          });
        }
      );
    }
    event.preventDefault();
  };

  infoMessage = () => {
    swal({
      imageUrl: CONSTANTS.swalLogo,
      title:
        '<div class="titleModal">You can cancel your subscription in your device.</div>',
      html: '<p class="contentModal"></p>',
      showConfirmButton: false,
      showCloseButton: true,
      background: '#121C24',
      allowOutsideClick: false
    });
  };

  displaySubscription = (subscription) => {
    // support mobile originated subscriptions (Alexa, Apple)

    const nextBillingDateA = convertDate(subscription.ended);
    const lastBillingDateA = convertDate(subscription.started);
    const customerEmailA = subscription.user.email;
    const customerFirstnameA = subscription.user.name;

    if (!isMobile) {
      return (
        <div className="row" key={subscription.productId}>
          <div>
            <div
              className="headerDivDesc"
              style={{ textAlign: 'center' }}
            >{`Your ${subscription.type} Premium Subscription`}</div>
            <div style={{ padding: '8px' }}>
              <div className="textInfo">Purchase Date: {lastBillingDateA}</div>
              <div className="textInfo">Expiry Date: {nextBillingDateA}</div>
              <div className="textInfo">Name: {customerFirstnameA}</div>
              <div className="textInfo">Email: {customerEmailA}</div>
            </div>
            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              <Button
                type="button"
                className="btn-general btn-paypal"
                onClick={this.infoMessage.bind(this)}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div key={subscription.productId}>
        <h3>{`Your ${subscription.type} Premium Subscription`}</h3>
        <h4>Purchase Date: {lastBillingDateA}</h4>
        <h4>Expiry Date: {nextBillingDateA}</h4>
        <h4>Name: {customerFirstnameA}</h4>
        <h4>Email: {customerEmailA}</h4>
        <div className="center">
          <Button type="button" onClick={this.infoMessage.bind(this)}>
            Cancel Subscription
          </Button>
        </div>
      </div>
    );
  };

  displayBraintreeSubscription = (
    subscription,
    appleSubscriptions,
    alexaSubscriptions
  ) => {
    let lastBillingDate;
    let nextBillingDate;
    let date;
    let day;
    let month;
    let year;
    let customerFirstname;
    let customerEmail;
    let customerLastname;
    let customerPhone;
    let braintreeStatus = 'CANCELED';
    let planName;
    let planPrice;

    const user = this.props.podcastUser;
    const subscriptions = this.state.subscriptions;
    const firebaseInfo = this.props.firebaseInfo;

    const username = firebaseInfo ? firebaseInfo.email : '';
    const name =
      firebaseInfo && firebaseInfo.name !== null
        ? firebaseInfo.name
        : user
        ? user.name
        : '';

    if (subscriptions === null) {
      braintreeStatus = 'CANCELED';
    }

    // use data from api/subscriptions API until data fully migrated to api/mysubscriptions
    if (
      subscriptions &&
      subscriptions[1] &&
      subscriptions[1].subscriptionType === 'Braintree'
    ) {
      date = new Date(subscriptions[1].nextBillingDate);
      day = date.getDate();
      month = date.getMonth() + 1;
      year = date.getFullYear();

      nextBillingDate = month + '/' + day + '/' + year;

      date = new Date(subscriptions[1].lastBillingDate);
      day = date.getDate();
      month = date.getMonth() + 1;
      year = date.getFullYear();

      lastBillingDate = month + '/' + day + '/' + year;

      customerEmail = subscriptions[1].customerEmail;
      customerFirstname = subscriptions[1].customerFirstname;
      customerLastname = subscriptions[1].customerLastname;
      customerPhone = subscriptions[1].customerPhone;

      braintreeStatus = subscriptions[1].status;
      planName = subscriptions[1].planName;
      planPrice = subscriptions[1].planPrice;

      // user has full access to his/her premium account
      if (
        this.context.userStatus === 'subscribed' &&
        subscription.status === 'subscribed'
      ) {
        if (!isMobile) {
          return (
            <div key={subscription.subscriptionId}>
              <div>
                <div>
                  <div
                    className="headerDivDesc"
                    style={{ textAlign: 'center' }}
                  >
                    Your Braintree Premium Subscription
                  </div>
                  <div style={{ padding: '8px' }}>
                    <div className="textInfo">
                      Paid Through Date: {lastBillingDate}
                    </div>
                    <div className="textInfo">
                      Next Payment Due Date: {nextBillingDate}
                    </div>
                    <div className="textInfo">Plan Name: {planName}</div>
                    <div className="textInfo">
                      Plan Price: $
                      {subscriptions && subscriptions[1] ? planPrice : 0}
                    </div>
                  </div>
                  <PaypalPremium
                    email={customerEmail}
                    name={customerFirstname}
                    surname={customerLastname}
                    phone={customerPhone}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div key={subscription.subscriptionId}>
              <h3>Your Braintree Premium Subscription</h3>
              <h4>Paid Through Date: {lastBillingDate}</h4>
              <h4>Next Payment Due Date: {nextBillingDate}</h4>
              <h4>Plan Name: {planName}</h4>
              <h4>
                Plan Price: ${subscriptions && subscriptions[1] ? planPrice : 0}
              </h4>
              <PaypalPremium
                email={customerEmail}
                name={customerFirstname}
                surname={customerLastname}
                phone={customerPhone}
              />
            </div>
          );
        }
      }

      // user access has been expired
      if (
        this.context.userStatus === 'inactive' &&
        subscription.status === 'nosubscribed' &&
        appleSubscriptions === null &&
        alexaSubscriptions === null
      ) {
        if (!isMobile) {
          return (
            <div key={subscription.subscriptionId}>
              <div>
                <div>
                  <div
                    className="headerDivDesc"
                    style={{ textAlign: 'center' }}
                  >
                    Your subscription has ended
                  </div>
                  {braintreeStatus ? (
                    <Paypal name={name} email={username} />
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div key={subscription.subscriptionId}>
              <h3>Your subscription has ended</h3>
              {braintreeStatus ? <Paypal name={name} email={username} /> : ''}
            </div>
          );
        }
      }
    }

    return null;
  };

  onChangeHandler = (e) => {
    let values = {};
    let checked = e;

    if (checked) {
      this.setState({ autoplay: true });
      values.auto_play_serial = checked;
      values.auto_play_serial_dont_ask = false;
      sessionStorage.removeItem('auto_play_serial');
    } else {
      this.setState({ autoplay: false });
      values.auto_play_serial = checked;
      values.auto_play_serial_dont_ask = false;
      sessionStorage.removeItem('auto_play_serial');
    }

    if (firebase.auth.currentUser !== null) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(updateUserFields(token, values));
      });
    }
  };

  onChangeHandlerAutoTagging = (e) => {
    let values = {};
    let checked = e;

    this.setState({ autotagging: checked });
    values.auto_tagging = checked;

    if (firebase.auth.currentUser !== null) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(updateUserFields(token, values));
      });
    }
  };

  autoplay = () => {
    let autoplay = false;
    if (this.props.userFields !== null && this.props.userFields !== undefined) {
      if (this.props.userFields.auto_play_serial !== undefined) {
        autoplay = this.props.userFields.auto_play_serial;
      }
    }
    //check if true in session
    if (sessionStorage.getItem('auto_play_serial') !== null) {
      if (sessionStorage.getItem('auto_play_serial') === 'true') {
        autoplay = true;
      } else {
        autoplay = false;
      }
    }
    return autoplay;
  };

  render() {
    const { newpassword, newpasswordconfirmation, fullname } = this.state;

    const isInvalidPsw =
      newpassword === '' ||
      newpasswordconfirmation === '' ||
      newpassword.length < 6 ||
      newpassword !== newpasswordconfirmation;

    const user = this.props.podcastUser;
    const subscriptions = this.state.subscriptions;
    const mysubscriptions = this.props.mysubscriptions;
    const firebaseInfo = this.props.firebaseInfo;

    const username = firebaseInfo ? firebaseInfo.email : '';
    const originalName = firebaseInfo ? firebaseInfo.name : '';
    const provider = firebaseInfo ? firebaseInfo.providerId : '';
    const name =
      firebaseInfo && firebaseInfo.name !== null
        ? firebaseInfo.name
        : user
        ? user.name
        : '';

    const isInvalidName =
      typeof fullname === 'undefined' ||
      fullname === '' ||
      fullname === originalName;

    let braintreeSubscriptions = null;
    let appleSubscriptions = null;
    let alexaSubscriptions = null;
    let braintreeStatus = 'CANCELED';

    if (subscriptions === null) {
      braintreeStatus = 'CANCELED';
    }

    // Apple
    if (
      this.context.userStatus !== 'inactive' &&
      mysubscriptions['Apple'] !== undefined
    ) {
      appleSubscriptions = mysubscriptions['Apple'].reduce(
        (appleSubscriptions, subscription) => {
          if (subscription.status === 'subscribed') {
            appleSubscriptions.push(this.displaySubscription(subscription));
          }

          return appleSubscriptions.length ? appleSubscriptions : null;
        },
        []
      );
    }

    // Alexa
    if (
      this.context.userStatus !== 'inactive' &&
      mysubscriptions['Alexa'] !== undefined
    ) {
      alexaSubscriptions = mysubscriptions['Alexa'].reduce(
        (alexaSubscriptions, subscription) => {
          if (subscription.status === 'subscribed') {
            alexaSubscriptions.push(this.displaySubscription(subscription));
          }

          return alexaSubscriptions.length ? alexaSubscriptions : null;
        },
        []
      );
    }

    // Braintree
    if (mysubscriptions['Braintree'] !== undefined) {
      braintreeSubscriptions = mysubscriptions['Braintree'].reduce(
        (braintreeSubscriptions, subscription) => {
          const sub = this.displayBraintreeSubscription(
            subscription,
            appleSubscriptions,
            alexaSubscriptions
          );

          if (sub !== null) {
            braintreeSubscriptions.push(
              this.displayBraintreeSubscription(
                subscription,
                appleSubscriptions,
                alexaSubscriptions
              )
            );
          }

          return braintreeSubscriptions;
        },
        []
      );

      braintreeSubscriptions = braintreeSubscriptions.length
        ? braintreeSubscriptions
        : null;
    }

    // user is still not subscribed but has a free period to access his/her premium account
    if (this.context.userStatus === 'free') {
      let endDateTrial;
      if (user) {
        endDateTrial = user.endDateTrial;
        var ts = new Date(endDateTrial);
        endDateTrial = ts.toLocaleDateString();
      }

      if (!isMobile) {
        braintreeSubscriptions = (
          <div>
            <div className="profile-label">Subscription Plan</div>
            <div style={{ fontWeight: 100 }}>
              Your free trial expires on {endDateTrial || 'unknown'}
            </div>
            <Paypal name={name} email={username} />
          </div>
        );
      } else {
        braintreeSubscriptions = (
          <div>
            <h3>Your free trial expires on {endDateTrial || 'Unknown'}</h3>
            <Paypal name={name} email={username} />
          </div>
        );
      }
    }

    // user access has been expired
    if (this.context.userStatus === 'inactive') {
      if (!isMobile) {
        braintreeSubscriptions = (
          <div className="square-container">
            <div>
              <div>Your subscription has ended</div>
              {braintreeStatus ? <Paypal name={name} email={username} /> : ''}
            </div>
          </div>
        );
      } else {
        braintreeSubscriptions = (
          <div>
            <h3>Your subscription has ended</h3>
            {braintreeStatus ? <Paypal name={name} email={username} /> : ''}
          </div>
        );
      }
    }

    const showAutotag = () => {
      const categoryTypesList = this.props.categoryTypesByUser?.categoryTypes;
      if (categoryTypesList?.length > 0) {
        let array = categoryTypesList?.filter(
          (categoryType) =>
            categoryType.autotags?.length > 0 &&
            categoryType.podcastTypeName === 'Enterprise'
        );
        if (array.length > 0) {
          return true;
        }
      }
      return false;
    };

    const renderProfile = () => {
      const isAppleId = this.props.firebaseInfo?.providerId === 'apple.com';

      return (
        <div className="profile-settings">
          <div>
            <div>
              <form onSubmit={this.onSubmitName.bind(this)}>
                <div className="profile-section-title">Profile & Settings</div>
                <div>
                  <div className="profile-label">EMAIL / USERNAME</div>
                  <span
                    style={{
                      color: '#eee',
                      fontSize: 18,
                      fontWeight: 100,
                      lineHeight: '32px'
                    }}
                  >
                    {!isAppleId ? (
                      <>{username}</>
                    ) : (
                      <b>Signed in with Apple ID</b>
                    )}
                  </span>
                </div>
                <div>
                  {provider === 'password' ? (
                    <FormGroup controlId="fullname">
                      <div className="profile-label">Full Name</div>

                      <FormControl
                        componentClass="input"
                        className="styleFieldProfile"
                        placeholder="Full Name"
                        type="text"
                        defaultValue={this.state.nameOfUser}
                        onChange={(event) =>
                          this.setState(
                            byPropKey('fullname', event.target.value)
                          )
                        }
                      />
                    </FormGroup>
                  ) : (
                    <>
                      {!isAppleId && (
                        <>
                          <div className="profile-label">Full Name</div>
                          <div
                            style={{
                              color: '#eee',
                              fontSize: 18,
                              marginBottom: 18,
                              fontWeight: 100
                            }}
                          >
                            {this.state.nameOfUser || 'Unknown Name'}{' '}
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>

                {provider === 'password' && (
                  <div>
                    <div style={{ width: 180 }}>
                      <button
                        type="submit"
                        disabled={isInvalidName}
                        className="login-btn button-oval button-cta2-24"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </form>
              {provider === 'password' ? (
                <div>
                  <div className="profile-label">Change Password</div>
                  <form onSubmit={this.onSubmitPassword.bind(this)}>
                    <div>
                      <div>
                        <FormGroup controlId="newpassword">
                          <FormControl
                            componentClass="input"
                            className="styleFieldProfile inline"
                            placeholder="New password"
                            type={this.state.showPass ? 'text' : 'password'}
                            onChange={(event) =>
                              this.setState(
                                byPropKey('newpassword', event.target.value)
                              )
                            }
                          />
                          <i
                            className={`fa ${
                              this.state.showPass ? 'fa-eye' : 'fa-eye-slash'
                            } showHideIcon profile`}
                            onClick={this.toggleShowHide}
                            aria-hidden="true"
                            title="Show/Hide Password"
                          ></i>
                        </FormGroup>
                        <FormGroup
                          controlId="newpasswordconfirmation"
                          style={{ marginTop: -20, marginBottom: 2 }}
                        >
                          <FormControl
                            componentClass="input"
                            className="styleFieldProfile inline"
                            placeholder="Confirm New Password"
                            type={this.state.showPass ? 'text' : 'password'}
                            onChange={(event) =>
                              this.setState(
                                byPropKey(
                                  'newpasswordconfirmation',
                                  event.target.value
                                )
                              )
                            }
                          />
                          <i
                            className={`fa ${
                              this.state.showPass ? 'fa-eye' : 'fa-eye-slash'
                            } showHideIcon profile`}
                            onClick={this.toggleShowHide}
                            aria-hidden="true"
                            title="Show/Hide Password"
                          ></i>
                        </FormGroup>
                        <div>
                          <div style={{ width: 180 }}>
                            <button
                              type="submit"
                              disabled={isInvalidPsw}
                              className="login-btn button-oval button-cta2-24"
                            >
                              Change Password
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                ''
              )}
              <div>
                <div className="profile-label" style={{ marginTop: 24 }}>
                  Settings
                </div>
                <div>
                  <div style={{ color: '#EDEEEF' }}>
                    <label>
                      <div
                        style={{
                          color: '#EDEEEF',
                          fontWeight: 200,
                          display: 'inline-block',
                          width: 170,
                          marginBottom: 12
                        }}
                      >
                        Auto Play Mode
                      </div>
                      <Switch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        onColor="#7634a9"
                        offColor="#ccc"
                        onChange={this.onChangeHandler}
                        checked={this.state.autoplay}
                        className="react-switch"
                      />
                    </label>
                  </div>
                </div>
                {showAutotag() ? (
                  <>
                    <div style={{ color: '#EDEEEF' }}>
                      <label>
                        <div
                          style={{
                            color: '#EDEEEF',
                            fontWeight: 200,
                            display: 'inline-block',
                            width: 170,
                            marginBottom: 12
                          }}
                        >
                          Auto Ai Tags
                        </div>
                        <Switch
                          uncheckedIcon={false}
                          checkedIcon={false}
                          onColor="#7634a9"
                          offColor="#ccc"
                          onChange={this.onChangeHandlerAutoTagging}
                          checked={this.state.autotagging}
                          className="react-switch"
                        />
                      </label>
                    </div>
                    <div
                      style={{
                        fontSize: '10pt',
                        color: '#EDEEEF',
                        marginTop: '10px',
                        marginLeft: 12
                      }}
                    >
                      Turn on to automatically have Ai tag your highlighted
                      Sentences.
                    </div>
                    <div
                      className="row"
                      style={{
                        fontSize: '10pt',
                        color: '#EDEEEF',
                        marginBottom: 12,
                        marginLeft: 12
                      }}
                    >
                      When On, you can still manually set your own tag when
                      needed.
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    };

    const renderSubscription = () => {
      const isSubscriptionLoading = this.state.isSubscriptionLoading;

      return (
        <div className="profile-subscription">
          <div className="profile-section-title">Your Subscription</div>
          {isSubscriptionLoading && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <LoadingDots />
            </div>
          )}
          {braintreeSubscriptions !== null ? (
            <div>{braintreeSubscriptions}</div>
          ) : null}
          {appleSubscriptions !== null || alexaSubscriptions !== null ? (
            <div>
              {appleSubscriptions}
              {alexaSubscriptions}
            </div>
          ) : null}
        </div>
      );
    };

    return (
      <React.Fragment>
        <div>
          <Navigation />
          <Dialog
            ref={(el) => {
              this.dialog = el;
            }}
          />
          <div className="main-page">
            <div className="page-title">My Account</div>
            <div className="row">
              {renderProfile()}
              {renderSubscription()}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ProfilePage.contextType = AuthUserContext;

ProfilePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userFields: PropTypes.object
};

const mapStateToProps = (store) => {
  return {
    podcastUser: store.user.podcastUser,
    firebaseInfo: store.user.firebaseInfo,
    subscriptions: store.user.subscriptions,
    mysubscriptions: store.user.mysubscriptions,
    userFields: store.app.userFields,
    categoryTypesByUser: store.user.categoryTypesByUser
  };
};

const authCondition = (authUser) =>
  !!authUser &&
  authUser.userStatus &&
  (isUserStatusSubscribed(authUser.userStatus) ||
    isUserStatusFree(authUser.userStatus) ||
    isUserStatusNew(authUser.userStatus) ||
    isUserStatusInactive(authUser.userStatus));

export default withAuthorization(authCondition)(
  connect(mapStateToProps)(ProfilePage)
);
